/** Texts of the findings block (docs/architecture/findings.md). In German UI texts "Mängel". */
export const findingsDe = {
  title: 'Mängel',
  summary: '{{open}} offen von {{total}}',
  numbered: 'Mangel {{number}}',
  numberedPositive: 'Positive Feststellung {{number}}',
  cardName: 'Mangel {{number}}: {{title}}',
  cardNamePositive: 'Positive Feststellung {{number}}: {{title}}',
  add: 'Mangel erfassen',
  copy: 'Mängel übernehmen',
  more_one: '{{count}} weiteren anzeigen',
  more_other: '{{count}} weitere anzeigen',
  empty: 'Noch keine Mängel',
  emptyHint: 'Mängel aus dem Mängelkatalog übernehmen oder frei erfassen.',
  emptyFiltered: 'Keine Mängel für diese Filter',
  emptyFilteredHint: 'Suchbegriff oder Filter ändern oder die Filter zurücksetzen.',
  loadFailed: 'Die Mängel konnten nicht geladen werden.',
  unavailable: 'Ohne Verbindung nicht verfügbar',
  unavailableHint: 'Die Mängel dieses Eintrags sind nicht auf diesem Gerät gespeichert.',
  offline: 'Ohne Verbindung nur zum Ansehen.',
  offlineHeld:
    'Ohne Verbindung: Änderungen bleiben auf dem Gerät und werden übertragen, sobald wieder eine Verbindung besteht.',
  views: { label: 'Ansicht', list: 'Liste', plan: 'Mängelplan', map: 'Mängelkarte' },
  filters: {
    search: 'Mängel durchsuchen',
    searchPlaceholder: 'Nummer, Titel, Ort …',
    status: 'Status',
    category: 'Kategorie',
    priority: 'Priorität',
    allStatuses: 'Alle Status',
    open: 'Alle offenen',
    positive: 'Positive Feststellungen',
    noStatus: 'Ohne Status',
    allCategories: 'Alle Kategorien',
    noCategory: 'Ohne Kategorie',
    allPriorities: 'Alle Prioritäten',
    noPriority: 'Ohne Priorität',
  },
  overview: {
    label: 'Mängel nach Status',
    noStatus: 'Ohne Status',
    positive: 'Positiv',
    pending_one: '{{count}} wartet auf die Übertragung',
    pending_other: '{{count}} warten auf die Übertragung',
  },
  card: {
    positions_one: '{{count}} Standort',
    positions_other: '{{count}} Standorte',
    photos_one: '{{count}} Foto',
    photos_other: '{{count}} Fotos',
    due: 'Fällig bis {{date}}',
    overdue: 'Überfällig, fällig bis {{date}}',
    resolved: 'Erledigt am {{date}}',
    geo_one: 'GPS-Punkt',
    geo_other: '{{count}} GPS-Punkte',
    positive: 'Positiv',
    responsible: 'Verantwortlich: {{name}}',
    dueNote: 'Frist: {{text}}',
  },
  start: {
    label: 'Mit Foto starten',
    hint: 'Optional zuerst ein Foto aufnehmen oder auswählen, dann den Mangel im Katalog suchen.',
    chosen_one: 'Das Foto kommt an den Mangel, der jetzt angelegt wird.',
    chosen_other: 'Die {{count}} Fotos kommen an den Mangel, der jetzt angelegt wird.',
    alt: 'Foto {{index}} für den neuen Mangel',
    removeDescription: 'Das Foto wird nicht übernommen.',
  },
  sheet: {
    pickAt: 'Mangel an dieser Stelle',
    free: 'Mangel frei erfassen',
    positive: 'Positives erfassen',
    ai: 'Mangel mit KI erfassen',
    back: 'Zurück zum Mängelkatalog',
  },
  picker: {
    search: 'Im Mängelkatalog suchen',
    searchPlaceholder: 'z. B. Feuerlöscher, Fluchtweg, ASR A2.3',
    enterHint: 'Enter übernimmt den ersten Treffer.',
    group: 'Gruppe',
    allGroups: 'Alle Gruppen',
    noGroup: 'Ohne Gruppe',
    category: 'Kategorie',
    allCategories: 'Alle Kategorien',
    noCategory: 'Ohne Kategorie',
    filters: 'Gruppe und Kategorie filtern',
    filtersActive_one: 'Gruppe und Kategorie filtern, {{count}} Filter aktiv',
    filtersActive_other: 'Gruppe und Kategorie filtern, {{count}} Filter aktiv',
    templates_one: '{{count}} Vorlage',
    templates_other: '{{count}} Vorlagen',
    free: 'Frei erfassen',
    freeShort: 'Frei',
    positive: 'Positives erfassen',
    positiveShort: 'Positiv',
    ai: 'Mit KI erfassen',
    aiShort: 'Mit KI',
    hits_one: '{{count}} Treffer',
    hits_other: '{{count}} Treffer',
    frequent: 'Häufig verwendet',
    usage_one: 'Einmal verwendet',
    usage_other: '{{count}}-mal verwendet',
    more_one: '{{count}} weitere Vorlage anzeigen',
    more_other: '{{count}} weitere Vorlagen anzeigen',
    details: 'Details',
    detailsOf: 'Details zu „{{title}}“',
    take: 'Vorlage übernehmen',
    loadFailed: 'Der Mängelkatalog konnte nicht geladen werden.',
    noCatalog: 'Noch kein Mängelkatalog',
    noCatalogHint:
      'Vorlagen pflegt die Verwaltung in den Einstellungen des Moduls. Bis dahin Mängel frei erfassen.',
    empty: 'Keine passende Vorlage',
    emptyHint: 'Suchbegriff oder Filter ändern oder den Mangel frei erfassen.',
  },
  free: {
    hint: 'Alles Weitere folgt im Formular.',
    required: 'Bitte einen Titel eingeben.',
    create: 'Mangel anlegen',
    positiveHint:
      'Etwas, das gut gelöst ist. Es steht im Bericht getrennt von den Mängeln und zählt nicht als Mangel.',
    createPositive: 'Positives anlegen',
  },
  toCatalog: {
    action: 'In Mängelkatalog aufnehmen',
    offline: 'Der Mängelkatalog lässt sich nur mit Verbindung ergänzen.',
  },
  ai: {
    improve: 'Mit KI verbessern',
    improveFailed: 'Es ließ sich kein Vorschlag erstellen. Bitte erneut versuchen.',
    discard: 'Verwerfen',
    keywords: 'Stichworte',
    keywordsHint: 'Keine Namen oder anderen Angaben zu Personen.',
    keywordsPlaceholder: 'z. B. Brandschutztür 2. OG verkeilt, Schließer fehlt',
    required: 'Bitte Stichworte eingeben.',
    draft: 'Vorschlag erstellen',
    positive: 'Positive Feststellung',
    positiveHint: 'Die KI beschreibt, was gut gelöst ist, statt eines Mangels.',
    failed: 'Es ließ sich kein Vorschlag erstellen. Bitte erneut versuchen oder frei erfassen.',
    offline: 'Die KI ist nur mit Verbindung verfügbar.',
    disclaimer: 'Bitte den Vorschlag prüfen. Nach dem Übernehmen lässt er sich im Formular ändern.',
    again: 'Stichworte ändern',
    take: 'Übernehmen',
    references: 'Rechtsbezüge für die Rechtsgrundlage',
    quote: '„{{quote}}“',
    quoteUnverified: 'Zitat nicht im Wortlaut',
  },
  form: {
    title: 'Titel',
    titleRequired: 'Der Titel darf nicht leer sein.',
    category: 'Kategorie',
    priority: 'Priorität',
    status: 'Status',
    description: 'Beschreibung',
    measure: 'Maßnahme',
    legalBasis: 'Rechtsgrundlage',
    legalBasisPlaceholder: 'z. B. ASR A2.3 Nr. 5',
    location: 'Ort',
    floor: 'Geschoss',
    area: 'Bereich',
    room: 'Raum',
    dates: 'Termine',
    positive: 'Positive Feststellung',
    positiveHint: 'Kein Mangel: steht im Bericht getrennt und zählt nicht als Mangel.',
    responsible: 'Verantwortlich',
    responsibleHint: 'Person oder Firma, die den Mangel behebt.',
    responsiblePlaceholder: 'Person oder Firma wählen oder eingeben',
    responsibleSearch: 'Suchen oder eingeben',
    responsibleUse: '„{{name}}“ übernehmen',
    responsibleEmpty: 'Kein Vorschlag. Namen eingeben.',
    foundOn: 'Festgestellt am',
    dueOn: 'Fällig bis',
    dueNote: 'Frist als Text',
    dueNotePlaceholder: 'z. B. täglich vor Arbeitsbeginn',
    dueNoteHint: 'Für Fristen ohne festen Tag, auch zusätzlich zum Datum.',
    dueSuggested: 'Vorschlag aus der Regelfrist der Priorität.',
    resolvedOn: 'Erledigt am',
    template: 'Aus der Vorlage „{{name}}“',
    source: 'Aus einem früheren Eintrag übernommen',
    done: 'Fertig',
    remove: 'Mangel löschen',
    removeTitle: 'Mangel {{number}} löschen?',
    removeDescription: 'Der Mangel wird mit seinen Fotos gelöscht.',
    removeConfirm: 'Löschen',
    removed: 'Mangel {{number}} gelöscht',
  },
  positions: {
    title: 'Standorte auf Plänen',
    empty: 'Noch kein Standort gesetzt.',
    noPlans: 'Für diesen Eintrag gibt es keine Pläne.',
    unknownPlan: 'Plan nicht verfügbar',
    page: 'Seite {{page}}',
    add: 'Standort setzen',
    change: 'Ändern',
    changeLabel: 'Standort {{index}} ändern',
    remove: 'Standort {{index}} entfernen',
  },
  photos: {
    title: 'Fotos',
    empty: 'Keine Fotos',
    hint: 'Höchstens {{max}} Fotos. Große Bilder werden vor dem Hochladen verkleinert.',
    take: 'Foto aufnehmen',
    choose: 'Fotos auswählen',
    adding_one: '{{count}} Foto wird vorbereitet …',
    adding_other: '{{count}} Fotos werden vorbereitet …',
    uploading: 'Wird hochgeladen',
    waiting: 'Wartet auf den Upload',
    refused: 'Abgelehnt: {{reason}}',
    alt: 'Foto {{index}} zu Mangel {{number}}',
    open: 'Foto {{index}} vergrößern',
    moveUp: 'Foto {{index}} nach vorne',
    moveDown: 'Foto {{index}} nach hinten',
    remove: 'Foto {{index}} entfernen',
    caption: 'Bildunterschrift zu Foto {{index}}',
    captionPlaceholder: 'Bildunterschrift',
    removeTitle: 'Foto entfernen?',
    removeDescription: 'Das Foto wird aus dem Mangel entfernt und gelöscht.',
    removeConfirm: 'Entfernen',
    viewer: {
      previous: 'Vorheriges Foto',
      next: 'Nächstes Foto',
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
      position: 'Foto {{index}} von {{count}}',
    },
  },
  plan: {
    plan: 'Plan',
    hint: 'Auf eine freie Stelle tippen, um dort einen Mangel zu erfassen. Ein Marker öffnet seine Mängel.',
    hintReadOnly: 'Ein Marker öffnet seine Mängel.',
    marker_one: 'Mangel {{labels}}',
    marker_other: 'Mängel {{labels}}',
    none: 'Keine Pläne',
    noneHint: 'Für diesen Eintrag gibt es noch keine Pläne oder sie sind nicht auf dem Gerät.',
    unplaced_one: '{{count}} Mangel hat keinen Standort auf einem Plan.',
    unplaced_other: '{{count}} Mängel haben keinen Standort auf einem Plan.',
    choose: 'Mangel wählen',
  },
  map: {
    label: 'Mängelkarte',
    hint: 'Auf eine freie Stelle tippen, um dort einen Mangel zu erfassen. Ein Marker öffnet seine Mängel.',
    hintReadOnly: 'Ein Marker öffnet seine Mängel.',
    unplaced_one: '{{count}} Mangel hat keinen GPS-Punkt.',
    unplaced_other: '{{count}} Mängel haben keinen GPS-Punkt.',
    fromPhotos: {
      action: 'GPS aus Fotos übernehmen',
      originals: 'Originale auswählen',
      hint: 'Jedes Foto mit Standort wird ein GPS-Punkt seines Mangels, Punkte näher als {{meters}} m zählen als einer. Ältere Uploads haben keinen Standort mehr: Dafür die Originalfotos aus der Galerie auswählen, die App erkennt sie am Dateinamen.',
      offline: 'GPS aus Fotos übernehmen braucht eine Verbindung.',
      done_one: '{{count}} GPS-Punkt übernommen.',
      done_other: '{{count}} GPS-Punkte übernommen.',
      none: 'Keine neuen GPS-Punkte.',
      missing_one: '{{count}} Foto hat keinen Standort.',
      missing_other: '{{count}} Fotos haben keinen Standort.',
      unmatched_one: '{{count}} Foto passt zu keinem Mangel.',
      unmatched_other: '{{count}} Fotos passen zu keinem Mangel.',
    },
  },
  geo: {
    title: 'GPS-Punkte',
    hint: 'Jedes Foto mit Standort setzt einen Punkt, Punkte näher als {{meters}} m zählen als einer. Sonst den Standort des Geräts nehmen, auf der Karte tippen oder Koordinaten einfügen.',
    empty: 'Noch kein GPS-Punkt.',
    point: 'Punkt {{index}}',
    change: 'Ändern',
    changeLabel: 'GPS-Punkt {{index}} ändern',
    remove: 'GPS-Punkt {{index}} entfernen',
    add: 'Weiteren Punkt setzen',
    adding: 'Neuer GPS-Punkt',
    editing: 'GPS-Punkt {{index}}',
    sources: {
      photo: 'Aus dem Foto',
      device: 'Standort des Geräts',
      map: 'Von Hand gesetzt',
    },
    accuracy: '±{{meters}} m',
    fromPhoto_one: 'GPS-Punkt aus dem Foto übernommen.',
    fromPhoto_other: '{{count}} GPS-Punkte aus den Fotos übernommen.',
    fromDevice: 'Das Foto hat keinen Standort, der GPS-Punkt kommt vom Gerät.',
  },
  copyDialog: {
    title: 'Mängel übernehmen',
    description:
      'Übernommen werden Texte, Kategorie, Priorität, Ort, Standorte, GPS-Punkte und Fotos. Status und Termine beginnen neu.',
    source: 'Aus',
    from: 'Aus: {{source}}',
    findings: 'Mängel',
    all: 'Alle',
    none: 'Keine',
    confirm_one: '{{count}} Mangel übernehmen',
    confirm_other: '{{count}} Mängel übernehmen',
    done_one: '{{count}} Mangel übernommen',
    done_other: '{{count}} Mängel übernommen',
    empty: 'Dieser Eintrag hat keine Mängel.',
    loadFailed: 'Die Mängel des früheren Eintrags konnten nicht geladen werden.',
    offline:
      'Ohne Verbindung nicht verfügbar: Die Mängel dieses früheren Eintrags sind nicht auf diesem Gerät.',
  },
  errors: {
    saveFailed: 'Die Änderung wurde nicht gespeichert.',
    createFailed: 'Der Mangel konnte nicht angelegt werden.',
    removeFailed: 'Der Mangel konnte nicht gelöscht werden.',
    copyFailed: 'Die Mängel konnten nicht übernommen werden.',
    photoFailed: '„{{name}}“ konnte nicht als Foto gespeichert werden.',
    'copy-same-record': 'Mängel lassen sich nicht in denselben Eintrag übernehmen.',
    'finding-catalog-invalid': 'Ein gewählter Katalogeintrag ist nicht mehr verfügbar.',
    'finding-exists': 'Diesen Mangel gibt es schon.',
    'finding-photo-invalid': 'Ein Foto gehört nicht zu diesem Mangel.',
    'finding-plan-invalid': 'Ein Standort liegt auf einem Plan, den es nicht mehr gibt.',
    'finding-too-large': 'Die Bildunterschriften sind zusammen zu lang.',
    'not-found': 'Diesen Mangel gibt es nicht mehr.',
    'offline-unavailable': 'Ohne Verbindung lässt sich das hier nicht speichern.',
    'too-many-findings': 'Ein Eintrag hat höchstens {{max}} Mängel.',
    'too-many-photos': 'Ein Mangel hat höchstens {{max}} Fotos.',
    'version-conflict': 'Der Mangel wurde inzwischen geändert. Die aktuelle Fassung wird geladen.',
  },
  catalogs: {
    statuses: {
      label: 'Status',
      description:
        'Status der Mängel in allen Modulen. Ein Status, der als erledigt gilt, zählt einen Mangel nicht mehr zu den offenen.',
    },
    priorities: {
      label: 'Prioritäten',
      description:
        'Dringlichkeit der Mängel mit Stufe (1 ist am dringendsten) und Regelfrist in Tagen für den Vorschlag „Fällig bis“.',
    },
    groups: {
      label: 'Gruppen',
      description: 'Oberbegriffe für Kategorien, z. B. baulicher Brandschutz.',
    },
    categories: {
      label: 'Kategorien',
      description: 'Einteilung der Mängel, jeweils mit Gruppe.',
    },
    templates: {
      label: 'Mängelkatalog',
      description:
        'Vorlagen mit Beschreibung, Maßnahme, Rechtsgrundlage und Priorität, aus denen Mängel entstehen.',
    },
  },
  catalogFields: {
    closed: 'Gilt als erledigt',
    level: 'Stufe',
    dueDays: 'Regelfrist in Tagen',
    group: 'Gruppe',
    category: 'Kategorie',
    priority: 'Priorität',
    description: 'Beschreibung',
    measure: 'Empfohlene Maßnahme',
    legalBasis: 'Rechtsgrundlage',
    keywords: 'Schlagworte',
  },
  settings: {
    title: 'Status und Prioritäten der Mängel',
    description:
      'Gelten für alle Module mit Mängeln. Eine Änderung hier gilt auch in den anderen Modulen.',
  },
};
